<template>
    <div class="home-region study">
        <div class="region-cont">
            <div class="tit tit-gray">学习专区 <div class="tit-bottom"></div></div>
            <div class="study-list">
                <ul class="list-nav">
                    <li class="list" v-for="(item,index) in studyList" :key="index">
                        <a @click="study_click(item,index)" :class="item.isClick?'avtive':''" @mouseenter="study_move(item)" @mouseleave="study_shift(item)">
                            <div class="nav-cont">
                                <p class="nav-tit">{{item.tit}}</p>
                                <p class="nav-txt">{{item.txt}}</p>
                            </div>
                            <div class="nav-icon">
                                <img  width="100%" :src="item.mouseenter?item.imgHover:item.img" alt="">
                            </div>
                        </a>
                    </li>
                </ul>
                
                <div class="list-info"> 
                    <ancientBooks v-show="studyIndex==0"></ancientBooks>
                    <listInfo v-show="studyIndex==1" mode="clinic"></listInfo>
                    <listInfo v-show="studyIndex==2" mode="tcm"></listInfo>
                    <listInfo v-show="studyIndex==3"  mode="topic"></listInfo> 
                </div>
                
            </div>
        </div>
    </div> 
</template>

<script>
import { bookList } from '../../../io/api';
import homeData from '../homeData.js';
import ancientBooks from './study/ancientBooks.vue'
// 学临床和学中药的列表组件
import listInfo from './study/listInfo.vue'
import topicInfo from './study/topicInfo.vue'
export default {
    components:{
        ancientBooks,
        listInfo,
        topicInfo,
    },
    data () {
        return {
            studyList:homeData.studyList,
            studyRadio:'1',
            studyListInfo:homeData.studyList[0],
            studyIndex:0
        }
    },
    mounted(){
        this.getStudyListInfo();
        this.getClinicInfo()
    },
    methods: {
        //学古籍
        getStudyListInfo(){
            let params={
                page: 1,
                limit: 6,
                keyWord:'',
                faceName:'',
                faceValue:'',
            };
            bookList(params).then(res => {
                let {code,data,msg}=res.data;
                if(code==0){
                    this.studyListInfo.list=data.list||[]; 
                }else{
                    this.$message.error(msg||'请求失败～');
                }
            })
        },
        //学临床
        getClinicInfo(){
            this.studyList[1].list=[
                {
                    tit:'儿科',
                    sublevel:['支气管哮喘 ','小儿肺炎 ','支气管炎 ','反复呼吸道感染 ','婴幼儿营养不良','厌食症 ','消化性溃疡 ','小儿腹泻 ']
                },
                {
                    tit:'内分泌科',
                    sublevel:['糖尿病 ','甲状腺功能亢进症 ','甲状腺功能减退症 ','甲状腺炎 ','肥胖症','慢性肾上腺皮质功能减退症 ','类风湿性关节炎 ','强直性脊柱炎']
                },
                {
                    tit:'肿瘤科',
                    sublevel:['鼻咽癌 ','食管癌 ','乳腺癌 ','原发性支气管肺癌 ','原发性肝癌','胃癌 ','胰腺癌 ','大肠癌']
                },
                {
                    tit:'呼吸科',
                    sublevel:['急性上呼吸道感染 ','急性气管-支气管炎 ','慢性支气管炎 ','肺炎 ','传染性非典型性肺炎','肺脓肿 ','肺结核 ','支气管扩张']
                },
                {
                    tit:'妇产科',
                    sublevel:['功能失调性子宫出血 ','闭经','痛经 ','经前期综合征 ','绝经综合征','盆腔炎性疾病 ','阴道炎 ','自然流产']
                },
                {
                    tit:'骨科',
                    sublevel:['肋骨骨折 ','肱骨外科颈骨折','肱骨髁上骨折 ','髋关节脱位 ','股骨颈骨折','胫骨平合骨折 ','胫腓骨干骨折 ','颈椎病']
                }
           
            ];
        },
        study_move(item) { 
			item.mouseenter = true
		},
        study_shift (item) { 
            if(item.isClick) return
			item.mouseenter = false
		},
        //切换右侧分类
        study_click(item,index){
            this.studyList.forEach(item => {
                item.isClick=false;
                item.mouseenter = false
            });
            item.isClick=true;
            item.mouseenter = true;
            this.studyIndex=index;
            // this.studyListInfo=this.studyList[index]; 
            // this.studyRadio =this.studyListInfo.radioList?this.studyListInfo.radioList[0].label:'';
        }, 
        toPage(item,type){   
            let query={ 
                changeflag:item.changeflag
            };
            let path=item.path;
            if(type=='book'){
                path='/bookCatalogue',
                query.id=item.id;
				
            }
            let url= this.$router.resolve({
                path,
                query
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} )
        },
    }
}
</script>

<style lang="less" scoped>
 // 学习专区
.study{ 
    min-width: 1200px;
    background: url('../../../assets/images/home/gray-page.png') no-repeat center;
    background-size: cover;
    .study-list{
        display: flex;
        justify-content: space-between;
        .list-nav{ 
            .list{
                width: 470px;
                height: 130px;//110px;
                margin-bottom:24px;// 10px;
                cursor: pointer;
                a{ 
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #FFFFFF;
                    border-radius: 12px;   
                    padding:0 20px ;
                    border: 1px solid #FFFFFF;
                    color: #5A6779;
                    &:hover,&.avtive{ 
                        background: #F1F5FE url('../../../assets/images/home/study-list-icon.png') no-repeat right center; 
                        border: 1px solid #386DE8;
                        color: #386DE8 ;
                        .list-btn{
                            border: 1px solid #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #fff;
                            .look-icon{
                                margin-left: 4px;
                                display: block;
                                width: 14px;
                                height: 6px;
                                background: url('../../../assets/images/home/look-icon.png') no-repeat;
                                background-size: contain;
                            }
                        }
                    }
                    .nav-cont{
                        width: 300px;
                        .nav-tit{ 
                            font-weight: bold;
                            font-size: 18px;
                            line-height: 36px;
                            // margin-bottom: 10px;
                        }
                        .nav-txt{
                            height: 48px;
                            line-height: 24px;
                            font-size: 14px;
                        }
                    }
                    .nav-icon{
                        width: 80px;
                    }
                }
            }
            
        }
        // .list-info{
        //     width: 710px;
        //     height: 590px;
        //     border-radius: 8px;
        //     padding:20px;
        //     background: #fff;
        //     box-shadow: 0px 2px 16px 8px rgba(22,93,255,0.04);
        //     .study-radio{
        //         display: flex;
        //         justify-content: flex-end;
        //         // margin-bottom: 10px;
        //     }
        //     ul{
        //         display: flex; 
        //         justify-content: space-between; 
        //         flex-wrap: wrap;
        //         .info {
                    
        //             margin: 8px 0;
        //             cursor: pointer;
        //             // 古籍flex布局
        //             &.ancient{
        //                 a{
        //                     display: flex;
        //                     justify-content: space-between;
                            
        //                     .info-pic{
        //                         width: 118px;
        //                         height: 118px;
        //                         background: #fff;
        //                         text-align: center;
        //                         padding:6px;
        //                     }
        //                     .info-txt{
        //                         width: 168px;
        //                     }
        //                 }
        //             }
        //             a{ 
        //                 width: 326px;
        //                 height: 150px; 
        //                 padding:14px; 
        //                 background: #FCFCFC;
        //                 border: 1px solid #E9ECEF; 
        //                 .info-txt{ 
        //                     color: #333;
        //                     font-size: 12px;
        //                     .txt-tit{ 
        //                         height: 16px; 
        //                         font-weight: bold;
        //                         font-size: 16px; 
        //                         line-height: 20px;  
        //                         margin-bottom: 10px;
        //                     }
        //                     .txt{
        //                         width: 160px; 
        //                         font-weight: 400;
        //                         color: #5A6779;
        //                         line-height: 18px;  
        //                     } 
        //                     .txt-info{
        //                         .txt-clamp2();
        //                         height: 36px; 
        //                     }
        //                     .sublevel-txt{
        //                         display: flex;
        //                         flex-wrap: wrap;
        //                         span{
        //                             width: 148px;
        //                             padding:4px 0;
        //                         }
        //                     }
        //                 }
        //                 &:hover{ 
        //                     background: #EAF1FF;
        //                     box-shadow: 0px 2px 4px 0px rgba(22,93,255,0.04);
        //                     border: 1px solid #A0BDFF;
        //                     .info-txt,.txt,.sublevel-txt{
        //                         color: #386DE8;
        //                     } 
        //                 }
        //             }
                    
        //         }
        //     }
        //     .look-more{
        //         width: 96px;
        //         height: 32px;
        //         line-height: 32px;
        //         margin: 2px auto 0;
        //         border-radius: 16px;
        //         border: 1px solid #297BFF; 
        //         text-align: center;
        //         color: #297BFF;
        //         cursor: pointer;
        //     }
        //     .no-data{
        //         text-align: center;
        //         font-size: 18px;
        //         line-height: 32px;
        //         height: 32px;
        //         padding-top: 200px;
        //         // background: url('../../../assets/images/home/no-data.png') no-repeat center left;
        //         // background-size: contain;
        //     }
            
        // }
        
    }
    .txt-clamp2{
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        display: -webkit-box;
        -webkit-line-clamp: 2;//（文字行数）;;
        -webkit-box-orient: vertical;
    }
}
</style>